export default __webpack_public_path__ + "static/media/avatar.d7df8f3f.svg";